(() => {
  const TOPBAR_ID = "free-shipping-topbar";

  const scheduleUpdate = (() => {
    let t1 = null;
    let t2 = null;
    return () => {
      if (t1) clearTimeout(t1);
      if (t2) clearTimeout(t2);
      t1 = setTimeout(updateTopbar, 120);
      t2 = setTimeout(updateTopbar, 600);
    };
  })();

  async function getCartTotalYen() {
    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store",
      headers: { "Accept": "application/json" }
    });
    if (!res.ok) throw new Error("Failed to fetch /cart.js");
    const cart = await res.json();
    return (cart.total_price || 0) / 100;
  }

  function renderMessage(el, goalAmount, total, linkUrl) {
    if (!el || !el.isConnected) return;

    const textNode = el.querySelector(".free-shipping-topbar__text");
    if (!textNode) return;

    if (total >= goalAmount) {
      textNode.innerHTML = `🎉 送料無料です 🎉`;
      return;
    }

    const remain = goalAmount - total;
    textNode.innerHTML =
      `あと <strong>${remain.toLocaleString()}円</strong> で送料無料です！ ` +
      `<!--a href="${linkUrl}" class="free-shipping-topbar__link">&gt;商品の追加はこちら</a-->`;
  }

  async function updateTopbar() {
    const el = document.getElementById(TOPBAR_ID);
    if (!el) return;

    const goalAmount = Number(el.dataset.goalAmount || 5000);
    const linkUrl = el.dataset.linkUrl || "/collections/all";
    const showOnCart = (el.dataset.showOnCart || "true") === "true";

    // カートページで出したくない場合
    if (!showOnCart && location.pathname === "/cart") {
      el.classList.add("is-hidden");
      return;
    } else {
      el.classList.remove("is-hidden");
    }

    try {
      const total = await getCartTotalYen();
      renderMessage(el, goalAmount, total, linkUrl);
    } catch (e) {
      const textNode = el.querySelector(".free-shipping-topbar__text");
      if (textNode) textNode.textContent = "";
    }
  }

  function hookFetchAndXHR() {
    // fetch
    const origFetch = window.fetch;
    window.fetch = async function (...args) {
      const res = await origFetch.apply(this, args);
      try {
        const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
        if (
          url.includes("/cart/change") ||
          url.includes("/cart/update") ||
          url.includes("/cart/add") ||
          url.includes("/cart") ||
          url.includes("sections=") ||
          url.includes("/?sections=")
        ) {
          scheduleUpdate();
        }
      } catch (_) {}
      return res;
    };

    // XHR
    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__fst_url = url;
      return origOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener("loadend", () => {
        try {
          const url = this.__fst_url || "";
          if (
            url.includes("/cart/change") ||
            url.includes("/cart/update") ||
            url.includes("/cart/add") ||
            url.includes("/cart") ||
            url.includes("sections=") ||
            url.includes("/?sections=")
          ) {
            scheduleUpdate();
          }
        } catch (_) {}
      });
      return origSend.apply(this, args);
    };
  }

  function observeDOM() {
    const obs = new MutationObserver(() => {
      if (document.getElementById(TOPBAR_ID)) scheduleUpdate();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    hookFetchAndXHR();
    observeDOM();
    scheduleUpdate();
  });
})();
